import React, {useEffect, useState} from 'react';
import * as Icon from 'react-feather';
import {useSelector} from 'react-redux';
import {useAppDispatch} from '../../hooks/redux';

import {
    Input as AlchemyInput,
    Button as AlchemyButton,
    Textarea as AlchemyTextarea,
} from '@amzn/alchemy-components-react';

import { addBookmarkCard, updateBookmarkCard } from '../../slices/bookmarkCardsSlice';
import { loadEditBookmark, closeEditBookmark } from '../../slices/bookmarkModalSlice';
import { updateFavourite as updateMyFavouriteItem } from '../../slices/myFavouritesSlice';
import { updateFavourite as updateSiteFavouriteItem } from '../../slices/siteFavouritesSlice';
import { addMessage } from '../../slices/messageQueueSlice';
import { FavouritesApiService } from '../../api';
import { BookmarksApiService } from '../../api';
import { UrlPath } from '../../enums';
import i18n from "../../i18n";
import { RootState } from '../../types';

export default function() {
    // load user detail here
    const currentUser = useSelector((state: RootState) => state.user);
    // load modal status here
    const isVisible = useSelector((state: RootState) => state.bookmarkModal.editBookmark.visible);
    const modelData = useSelector((state: RootState) => state.bookmarkModal.editBookmark.model);
    // title is required, do validation while user typing
    const [isTitleNotValidated, setIsTitleNotValidated] = useState(false)

    const dispatch = useAppDispatch();
    // user input handling
    const [title, setTitle] = useState('');
    const [description, setDescription] = useState('');

    useEffect(() => {
        setTitle(modelData.title)
        setDescription(modelData.description)
    }, [modelData])

    const bmkApi = new BookmarksApiService()

    const handleSubmit = (e: React.MouseEvent) => {
        //send data to API and handle result
        async function editBookmark() {
            const r = await bmkApi.editBookmark(modelData.entity, title, description)
            // TODO: handle error
            console.log(r)
            // send to message queue
            dispatch(addMessage({
                id: Date.now().toString(),
                icon: "edit",
                title: i18n.t('toast:bookmark-updated'),
                text: title,
                duration: 5000
            }))
            //update the bookmarkcard
            dispatch(updateBookmarkCard({ entity: modelData.entity, title, description }))
            //update the favourites
            dispatch(updateMyFavouriteItem({ entity: modelData.entity, title, description }))
            dispatch(updateSiteFavouriteItem({ entity: modelData.entity, title, description }))
            // reset the modal
            dispatch(loadEditBookmark({}))
        }
        editBookmark()

        //TODO: update state
        dispatch(closeEditBookmark());
    }

    const handleTitleInput = (userInput: string) => {
        if (userInput.length !== 0) {
            setIsTitleNotValidated(false)
            setTitle(userInput)
        } else {
            setIsTitleNotValidated(true)
        }
    }

    const onCancel = () => {
        dispatch(closeEditBookmark());
    }

    const showHideClassName = isVisible ? "bookmark-modal display-block" : "bookmark-modal display-none"
    return (
        isVisible &&
        <div className={showHideClassName}>
            <div className="bookmark-modal-main">
                <div className='bookmark-modal-header'>
                    <div style={{height: "24px"}}><Icon.Edit /></div>
                    <div>{i18n.t('modal:edit-bookmark')}</div>
                    <div style={{height: "24px"}} onClick={onCancel}><Icon.X size="24" /></div>
                </div>
                <div className='bookmark-modal-body'>
                    <div className="basic-info">
                        <AlchemyInput name="Url"
                            label={i18n.t('universal:url')}
                            value={modelData.url}
                            disabled
                        />

                        <AlchemyInput name="Title"
                            label={`${i18n.t('universal:title')} (${i18n.t('modal:required')})`}
                            value={modelData.title}
                            onInput = {(e) => handleTitleInput(e.target.value)}
                            maxlength={40}
                        />
                        <AlchemyTextarea name="Description"
                            label={i18n.t('universal:description')}
                            rows={4}
                            notResizable={true}
                            maxlength={160}
                            value={modelData.description}
                            onInput = {(e) => setDescription(e.target.value)}
                        />
                    </div>
                    <div className="extra-info">
                        <div>UUID: {modelData.entity}</div>
                        <div>{i18n.t('modal:creator')}: {modelData.creator} ({i18n.t('modal:editing-by')} {currentUser.login})</div>
                        <div>{i18n.t('modal:created-at')}: {modelData.create_time}</div>
                    </div>
                </div>
                <div className='bookmark-modal-footer'>
                    <AlchemyButton variant="action" disabled={isTitleNotValidated} onClick={handleSubmit} >{i18n.t('modal:edit-bookmark')}</AlchemyButton>
                    <AlchemyButton onClick={onCancel} >{i18n.t('universal:cancel')}</AlchemyButton>
                </div>
            </div>
        </div>
    )
}
